import axios from "axios";

const DISABLE_FEEDBACK_NOTIFICATION = "notification/disable-feedback";
export const disableFeedbackNotification = () => {
  return axios.put(DISABLE_FEEDBACK_NOTIFICATION).then(data => data);
};
